module.exports = __webpack_public_path__ + "f45dc8ada49cc0c7900ed4277a95baa2.MP3";